import {
  FormCol, FormRow,
  RadioListControl,
  formatPhone,
  useScopedSelector,
} from 'ia-react-core';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useMarkPageLoaded } from 'omni-package-react-core';
import { MfaValidationPageState } from '../../../../interfaces/MfaValidationPageState';
import MfaCodeGeneration from '../../components/MfaCodeGeneration';
import { StyledLabel } from './MfaPhoneStep.styles';

export interface MfaPhoneStepProps { }

const MfaPhoneStep: FC<MfaPhoneStepProps> = () => {
  const { t, i18n } = useTranslation('MfaValidationPage');

  const method = useScopedSelector(({ values }: MfaValidationPageState) => values?.phone?.method, 'sms');

  useMarkPageLoaded();

  return (
    <MfaCodeGeneration
      method={method}
      informationType="phone"
      formatInfo={(info: string) => formatPhone(parseInt(info, 10), { locale: i18n.language })}
      submitButtonLabel={t(`steps.phone.methods.${method}.confirmButtonText`)}
    >
      <FormRow>
        <FormCol
          label={t('steps.phone.methodLabel')}
          data-testid="mfaPhoneMethod"
        >
          <RadioListControl
            name="method"
            noBox
            defaultValue="sms"
            options={[
              { label: <StyledLabel>{t('steps.phone.smsMethodLabel')}</StyledLabel>, value: 'sms' },
              { label: <StyledLabel>{t('steps.phone.callMethodLabel')}</StyledLabel>, value: 'voice' },
            ]}
          />
        </FormCol>
      </FormRow>
    </MfaCodeGeneration>
  );
};

export default MfaPhoneStep;
